"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.NorisSacrificeAbilityHandler = exports.NorisSacrificeActorAbilityFactory = exports.NorisSacrificeAbilityArgs = void 0;
const AbilityType_1 = require("../../core/abilities/AbilityType");
const ActorAbilityState_1 = require("../../core/actors/ActorAbilityState");
const AttributeType_1 = require("../../core/enums/AttributeType");
const Registries_1 = require("../../core/state/Registries");
const Target_1 = require("../../core/Target");
class NorisSacrificeAbilityArgs {
    constructor(target) {
        this.target = target;
        this.__type = AbilityType_1.AbilityType.NorisSacrifice;
        this.__typeName = "NorisSacrifice";
    }
}
exports.NorisSacrificeAbilityArgs = NorisSacrificeAbilityArgs;
let NorisSacrificeActorAbilityFactory = class NorisSacrificeActorAbilityFactory {
    mk() {
        return new ActorAbilityState_1.ActorAbilityState("NorisSacrifice", "AllAllies", 0, 1);
    }
};
NorisSacrificeActorAbilityFactory = __decorate([
    Registries_1.ActorAbilities.register("NorisSacrifice")
], NorisSacrificeActorAbilityFactory);
exports.NorisSacrificeActorAbilityFactory = NorisSacrificeActorAbilityFactory;
let NorisSacrificeAbilityHandler = class NorisSacrificeAbilityHandler {
    init(sequence, container, actorId) { }
    activate(sequence, container, ability) {
        container.applyAbilityAnimation({
            sequence,
            abilityKey: ability.args.__typeName,
            fallback: "casting",
            animatedId: ability.invokerId,
            onAnimated: sequence => {
                container.removeDebuffs({
                    sequence,
                    removerId: ability.invokerId,
                    targets: container.selectLivingTargets(ability.invokerId, Target_1.Target.AllAllies)
                        .map(targetId => ({
                        targetId,
                        includeSupernatural: false,
                        onDebuffsRemoved: sequence => {
                            container.applyHealing({
                                sequence,
                                healerId: ability.invokerId,
                                targetId,
                                amount: container.getMaxAttributeScore(targetId, AttributeType_1.AttributeType.Health)
                            });
                        }
                    }))
                });
            }
        });
    }
};
NorisSacrificeAbilityHandler = __decorate([
    Registries_1.Abilities.register(AbilityType_1.AbilityType.NorisSacrifice)
], NorisSacrificeAbilityHandler);
exports.NorisSacrificeAbilityHandler = NorisSacrificeAbilityHandler;
